"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AdminCdnPurgeComponent = void 0;
//ANGULAR2 BITS
const core_1 = require("@angular/core");
//INTERNAL BITS
const admin_service_1 = require("./admin.service");
const user_service_1 = require("./user.service");
const organizations_service_1 = require("./organizations.service");
const permission_service_1 = require("./permission.service");
const notification_service_1 = require("./notification.service");
const slug_pipe_1 = require("./slug.pipe");
const roles_service_1 = require("./roles.service");
const data_level_service_1 = require("./data-level.service");
const loading_service_1 = require("./loading.service");
let AdminCdnPurgeComponent = class AdminCdnPurgeComponent {
    constructor(_talk, _admin, _cd, _user, _organizations, _slug, _permission, _roles, _organization, _dataLevel, _loading) {
        this._talk = _talk;
        this._admin = _admin;
        this._cd = _cd;
        this._user = _user;
        this._organizations = _organizations;
        this._slug = _slug;
        this._permission = _permission;
        this._roles = _roles;
        this._organization = _organization;
        this._dataLevel = _dataLevel;
        this._loading = _loading;
        this.successfulHTTPReq = 200;
        this.showOrganization = false;
        this.fullPathText = 'Full Path';
        this.iIDPathText = 'iID';
        this.purgeFileModel = {
            path: '',
            bidderFileName: false,
            fullPath: false,
            switchToText: this.fullPathText
        };
    }
    ngOnInit() {
        this.permission = this._permission.get();
        this.user = this._user.get();
        this.roles = this._roles.get();
        this.dataLevelsDropDown = this._dataLevel.getAll();
        this.organizations = this._organization.get();
    }
    validatePurgePath() {
        let valid = false;
        if (this.purgeFileModel.fullPath) {
            // regex for http://brealtime.com/<see-below-explanation>.js
            // or .local.com or .dev.com
            valid = !!this.purgeFileModel.path.match(/^(http:|https:)\/\/biddr(.dev.|.local.|.)brealtime.com\/\d{1,}-\d{1,}.js$/g);
        }
        else {
            // regex:
            // ^\d{1,} -> starts with a digit, one or more, nothing comes before
            // [-] -> contains a dash
            // \d{1,}$ -> ends with a digit, one or more, nothing comes after
            valid = !!this.purgeFileModel.path.match(/^\d{1,}-\d{1,}$/g);
        }
        return valid;
    }
    togglePath() {
        this.purgeFileModel.fullPath = !this.purgeFileModel.fullPath;
        this.purgeFileModel.switchToText = this.purgeFileModel.fullPath ? this.iIDPathText : this.fullPathText;
    }
    cdnPurgeHelp() {
        this._talk.broadcast("When Def File iID is selected, enter only that file's iID without the file extension. This will purge the file for the environment you are current in (dev, local, staging, production). When Full File Path is selected, you may use any of the full def file paths for any of the 360 Suite environments you specify.");
    }
    purgeFile() {
        return __awaiter(this, void 0, void 0, function* () {
            if (!this.validatePurgePath()) {
                this._talk.broadcast('Invalid Path for the option selected.');
                return;
            }
            ;
            this._loading.start('Purging CDN...');
            try {
                let purgePrompt = yield this._admin.checkPurgeFile(this.purgeFileModel.path, this.purgeFileModel.fullPath);
                console.log('purgePrompt', purgePrompt);
                if (purgePrompt.status === this.successfulHTTPReq) {
                    this.purgeFileModel.bidderFileName = purgePrompt._body;
                    this.purgeConfirm();
                }
                this._loading.stop();
            }
            catch (err) {
                this._talk.broadcast(JSON.parse(err._body).message);
                this._loading.stop();
                throw new Error(err);
            }
        });
    }
    purgeConfirm() {
        return __awaiter(this, void 0, void 0, function* () {
            if (confirm(`Purge Bidder ${this.purgeFileModel.bidderFileName}?`)) {
                let response = yield this._admin.runFilePurge(this.purgeFileModel.path, this.purgeFileModel.fullPath);
                if (response.status === this.successfulHTTPReq) {
                    this._talk.broadcast("Successfully Purged!");
                }
            }
        });
    }
};
exports.AdminCdnPurgeComponent = AdminCdnPurgeComponent;
exports.AdminCdnPurgeComponent = AdminCdnPurgeComponent = __decorate([
    (0, core_1.Component)({
        selector: 'admin-cdn-purge',
        templateUrl: 'app/admin-cdn-purge.component.html',
        styleUrls: ['styles/admin.component.css'],
    }),
    (0, core_1.Injectable)(),
    __metadata("design:paramtypes", [notification_service_1.NotificationService,
        admin_service_1.AdminService,
        core_1.ChangeDetectorRef,
        user_service_1.UserService,
        organizations_service_1.OrganizationsService,
        slug_pipe_1.SlugPipe,
        permission_service_1.PermissionService,
        roles_service_1.RolesService,
        organizations_service_1.OrganizationsService,
        data_level_service_1.DataLevelService,
        loading_service_1.LoadingService])
], AdminCdnPurgeComponent);
//# sourceMappingURL=admin-cdn-purge.component.js.map